import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { Store } from '@ngrx/store'
import { FormBuilder, Validators } from '@angular/forms'
import * as fromState from '@tv3/store/state'
import { Toaster } from '@tokeet-frontend/tv3-platform'
import { startWith } from 'rxjs/operators'
import { widgetFontFamilies } from '@tv3/containers/widgets/shared/constants/font-families'
import { WebsiteService } from '@tv3/store/website/website.service'
import { AppConfig } from '@tv3/app.config'
import { compactObject } from '@tokeet-frontend/tv3-platform'
import { AmplitudeService } from '@tv3/services/amplitude.service'

@Component({
  selector: 'app-booking-widget',
  templateUrl: './interstitial-widget.component.html',
  styleUrls: ['./interstitial-widget.component.scss'],
})
export class InterstitialWidgetComponent implements OnInit {
  widgetCode = ''
  trustedWidgetCode: SafeHtml
  websiteEngines$ = this.websiteService.allEngines()
  fontFamilies = widgetFontFamilies

  form = this.fb.group({
    engine: [null],
    type: [null],
    showPrice: [true],
    showMinimumStay: [true],
    showTotalCost: [false],
    fontFamily: [null],
    buttonColor: ['#60c063'],
    buttonBorderWidth: [null],
    buttonBorderRadius: [null],
    bookButtonText: ['Book Now', [Validators.required]],
    enquiryButtonText: ['Inquiry', [Validators.required]],
    sendInquiryButtonText: ['Send Inquiry', [Validators.required]],
    showInputLabel: [true],
    showInputPlaceholder: [false],
  })

  constructor(
    private store: Store<fromState.State>,
    private appConfig: AppConfig,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private toast: Toaster,
    private websiteService: WebsiteService,
    private amplitudeService: AmplitudeService
  ) {}

  ngOnInit() {
    this.form.valueChanges.pipe(startWith(this.form.getRawValue())).subscribe((config) => {
      this.buildCode(config)
    })
  }

  buildCode(config) {
    if (!config.engine || !config.type) {
      return
    }

    const settings = {
      element: '#widget',
      engineDomain: config.engine.domain,
      type: config.type,
      showPrice: config.showPrice,
      showMinimumStay: config.showMinimumStay,
      showTotalCost: config.showTotalCost,
      bookButtonText: config.bookButtonText,
      enquiryButtonText: config.enquiryButtonText,
      sendInquiryButtonText: config.sendInquiryButtonText,
      showInputLabel: config.showInputLabel,
      showInputPlaceholder: config.showInputPlaceholder,
      apiBaseUrl: this.appConfig.config.apiBaseUrl,
      apiMailBaseUrl: this.appConfig.config.apiMailBaseUrl,
      style: {
        general: {
          fontFamily: config.fontFamily,
        },
        button: {
          backgroundColor: config.buttonColor,
          borderWidth: config.buttonBorderWidth,
          borderRadius: config.buttonBorderRadius,
        },
      },
    }

    compactObject(settings)

    this.widgetCode = `
<script src="https://s3.amazonaws.com/widgets.tokeet.com/widgets/interstitial/interstitial-widget.js?1554438722"></script>
<script>
window.tokeetIWSettings = ${JSON.stringify(settings, null, 2)};
</script>
<div id="widget"></div>
    `

    this.trustedWidgetCode = this.sanitizer.bypassSecurityTrustHtml(this.widgetCode)
  }

  onCopied($event) {
    this.toast.success($localize`Code copied.`)
    this.amplitudeService.logEvent('widget-interstitial-copied')
  }

  onColorSelected(key, color) {
    this.form.patchValue({ [key]: color })
  }
}
